import { useEffect }  from 'react';

export const useCollapseBanner = (
    portal,
    bannersList,
    setBannersCollapseTimer,
    setBannersCollapseTimerExpired,
    bannersCollapseTimer,
) => {
    // collapse banner if banners did not come in 40 sec
    useEffect(() => {
        if (portal && (!bannersList)) {
            setBannersCollapseTimer(
                setTimeout(() => {
                    setBannersCollapseTimerExpired(true);
                }, 40000)
            );
        }

        return () => {
            clearTimeout(bannersCollapseTimer);
        };
    }, [portal]);

    // cancel banners collapse if any banners became available
    useEffect(() => {
        if (bannersList) {
            clearTimeout(bannersCollapseTimer);
        }
    }, [bannersList]);
};
